import React from "react";
import { HeroSectionWrapper } from "./HeroSection.styles";
import HeroPanel from "./HeroPanel";
import VideoEmbed from "../Global/VideoEmbed/VideoEmbed";
import { GenericContentStyles } from "../Global/FlexipageStyles";
import { StatamicHtml, prefixStatamicAssetUrl } from "../../../utils/statamicAssets";

const assetSrc = (asset) => {
  if (!asset) return null;
  return prefixStatamicAssetUrl(asset.permalink || asset.url);
};

const HeroSection = ({ title, heroCopy, heroLeadImage, heroVideo, heroImage, heroIcon, heroPanels = [] }) => {

  const heroLeadImageSrc = assetSrc(heroLeadImage);
  let heroImageSrc = assetSrc(heroImage);
  const heroIconSrc = assetSrc(heroIcon);

  const heroImageAlt = heroImage?.alt || "lead image";
  const heroIconAlt = heroIcon?.alt || "hero icon image";

  let leadSectionClass = "lead-section no-grid";
  if (heroVideo) {
    leadSectionClass = "lead-section";
    heroImageSrc = false;
  } else if (heroImageSrc) {
    leadSectionClass = "lead-section";
  }

  const divStyle = heroLeadImageSrc
    ? {
        backgroundImage: `url(${heroLeadImageSrc})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100%",
        width: "100%",
      }
    : {
        height: "100%",
        width: "100%",
      };

  const panels = heroPanels
    .filter((panel) => panel && panel.label)
    .map((panel, idx) => (
      <HeroPanel key={idx} label={panel.label} link={panel.link} icon={panel.icon} />
    ));

  return (
    <HeroSectionWrapper data-animation-trigger="true">
      <div className="hero-background" style={divStyle}></div>
      <GenericContentStyles>
        <div className="hero-container">
          <div
            className={leadSectionClass}
            data-animation="animate__fadeIn"
            data-animation-duration="1s"
            data-animation-delay="0.1s"
          >
            <div className="copy-region">
              {heroIconSrc && (
                <div className="hero-icon-image">
                  <img src={heroIconSrc} alt={heroIconAlt} />
                </div>
              )}
              <h1 className="title" dangerouslySetInnerHTML={{ __html: title }}></h1>
              {heroCopy && <StatamicHtml html={heroCopy} />}
            </div>
            {heroVideo && (
              <div className="video-region">
                <div className="video-wrapper">
                  <VideoEmbed url={heroVideo} />
                </div>
              </div>
            )}
            {heroImageSrc && (
              <div className="hero-image">
                <img src={heroImageSrc} alt={heroImageAlt} />
              </div>
            )}
          </div>
          <div
            className="hero-panels"
            data-animation="animate__fadeIn"
            data-animation-duration="1s"
            data-animation-delay="1s"
          >
            {panels}
          </div>
        </div>
      </GenericContentStyles>
    </HeroSectionWrapper>
  );
};

export default HeroSection;
